/** @module Enums */ /** typedoc */

export enum SubscriptionMigrationTimingEnum {
    Now = 'Now',
    SpecificDate = 'SpecificDate',
    NextBillingPeriod = 'NextBillingPeriod'
}
